import { useState, useEffect } from "react";

/**
 * Returns T value based on the current viewport height
 * @param computeFn Function that receives current height and returns value
 */
export const useWhenWindowHeightChanges = <T>(
	computeFn: (height: number) => T
) => {
	const [margin, setMargin] = useState(computeFn(window.innerHeight));

	useEffect(() => {
		const handleResize = () => {
			setMargin(computeFn(window.innerHeight));
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [computeFn]);

	return margin;
};
